import React, { useCallback, useEffect, useState } from "react";
import moment from "moment";

import styles from "./InfoTab.module.scss";
import ProjectService from "api/Project/ProjectService";
import { ProjectInfo } from "models/ProjectInfo";

interface InfoTabProps {
  proj_id: string;
}

const InfoTab = ({ proj_id }: InfoTabProps) => {
  const [projectInfo, setProjectInfo] = useState<ProjectInfo>({
    project_created_timestamp: "",
    project_modified_timestamp: "",
    model_type: "pytorch",
    model_files: [],
  });

  const getData = useCallback(async () => {
    try {
      const response = await ProjectService.getProjectInfo(proj_id);

      if (response.info === undefined) {
        return;
      }

      setProjectInfo(response.info);
    } catch (err) {
      // handle error
    }
  }, [proj_id]);

  useEffect(() => {
    getData();
  }, [getData]);

  const formatFileSize = (fileSize: number) => {
    if (fileSize < 1000) {
      return `${fileSize}B`;
    } else if (fileSize < 1000000) {
      return `${Math.round(fileSize / 10000) * 100}KB`;
    } else {
      return `${Math.round(fileSize / 100000000) * 100}MB`;
    }
  };

  const formatDateString = (dateString: string) => {
    return moment(dateString).format("YYYY/MM/DD H:mm:ss");
  };

  return (
    <div className={styles.content}>
      <div className={styles.header}>
        <div className={styles.title}>Project Info</div>
      </div>

      <div className={styles.generalSection}>
        <div className={styles.sectionTitle}>General</div>
        <div className={styles.infoTable}>
          <span>Project Created:</span>
          <span className={styles.key}>
            {formatDateString(projectInfo.project_created_timestamp)}
          </span>
          <div className={styles.verticalSeparator} />
          <span>Project Modified:</span>
          <span className={styles.key}>
            {formatDateString(projectInfo.project_modified_timestamp)}
          </span>

          <span>Model Type:</span>
          <span className={styles.key}>{projectInfo.model_type}</span>
          <div className={styles.verticalSeparator} />
          {/* <span>Model Size:</span>
          <span>5.12GB</span> */}
        </div>
      </div>

      <div className={styles.filesSection}>
        <div className={styles.sectionTitle}>Files</div>
        <table className={styles.filesTable}>
          <tbody>
            {projectInfo.model_files.map((file) => (
              <tr key={file.name}>
                <td>{file.name}</td>
                <td className={styles.otherInfo}>
                  {formatFileSize(file.size)}
                </td>
                <td className={styles.otherInfo}>
                  {formatDateString(file.uploaded_date)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {/* <div className={styles.reuploadWeights}>Reupload Weights</div> */}
      </div>

      <div className={styles.historySection}>
        <div className={styles.sectionTitle}>History</div>
        <div className={styles.emptyHistory}>Nothing yet...</div>
      </div>
    </div>
  );
};

export default InfoTab;
